import React, { useState } from "react";
import { Button, Form, Grid } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";

const ESTATUS_OPTIONS = ["Alojado", "Finalizado", "En ruta", "No facturable", "Pendiente", "OV"];

const FormFacturacion = ({ accion, registro, cerrarModal, refrescar }) => {
  const isNew = !registro.id_facturacion;

  const [form, setForm] = useState({
    idMovimiento: registro.id_movimiento,
    envio: registro.envio || false,
    estatus: registro.estatus_facturacion || "",
    idSap: registro.id_sap || "",
    moneda: registro.moneda || "",
    tarifa: registro.tarifa ?? "",
    aplicoDescuento: registro.aplico_descuento || false,
    porcentajeDescuento: registro.porcentaje_descuento ?? "",
    notaCredito: registro.nota_credito || "",
    imputable: registro.imputable || "",
    folioFactura: registro.folio_factura || "",
    nota: registro.nota || "",
  });

  const [errores, setErrores] = useState({});
  const [guardando, setGuardando] = useState(false);

  const normalizarNumero = (valor) => {
    if (valor === "" || valor === null) return "";
    const num = parseFloat(valor);
    return isNaN(num) ? "" : String(num);
  };

  const handleChange = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErrores(prev => ({ ...prev, [campo]: undefined }));
  };

  const validar = () => {
    const nuevosErrores = {};
    if (!form.estatus) nuevosErrores.estatus = "Seleccione un estatus";
    if (form.tarifa !== "" && (isNaN(form.tarifa) || Number(form.tarifa) < 0))
      nuevosErrores.tarifa = "Tarifa debe ser un número >= 0";
    if (form.porcentajeDescuento !== "" && (isNaN(form.porcentajeDescuento) || Number(form.porcentajeDescuento) < 0 || Number(form.porcentajeDescuento) > 100))
      nuevosErrores.porcentajeDescuento = "Debe ser entre 0 y 100";
    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const guardar = () => {
    if (!validar() || guardando) return;
    setGuardando(true);

    const payload = {
      ...form,
      tarifa: form.tarifa !== "" ? parseFloat(form.tarifa) : null,
      porcentajeDescuento: form.porcentajeDescuento !== "" ? parseFloat(form.porcentajeDescuento) : null,
      nota: form.estatus === "Pendiente" ? form.nota : null,
    };

    const metodo = isNew ? "post" : "put";
    const url = isNew
      ? "movimientos-facturar/facturacion"
      : `movimientos-facturar/facturacion/${form.idMovimiento}`;

    Crud_Catalogos(url, "movimientosFacturar", metodo, "", payload, "", "", "", [])
      .then((res) => {
        if (res && res.status === 404 && !isNew) {
          // No existía, reintentar con POST
          return Crud_Catalogos(
            "movimientos-facturar/facturacion", "movimientosFacturar", "post", "", payload, "", "", "", []
          );
        }
        return res;
      })
      .then(() => {
        NotificationManager.success("Datos guardados correctamente");
        if (refrescar) refrescar();
        if (cerrarModal) cerrarModal();
      })
      .catch((err) => {
        const status = err && err.response && err.response.status;
        if (status === 404 && !isNew) {
          Crud_Catalogos(
            "movimientos-facturar/facturacion", "movimientosFacturar", "post", "", payload, "", "", "", []
          ).then(() => {
            NotificationManager.success("Datos guardados correctamente");
            if (refrescar) refrescar();
            if (cerrarModal) cerrarModal();
          }).catch(() => {
            NotificationManager.error("Error al guardar");
          }).finally(() => setGuardando(false));
        } else {
          NotificationManager.error("Error al guardar");
          setGuardando(false);
        }
      });
  };

  return (
    <div style={{ padding: "20px" }}>
      <h5>Facturación - Movimiento {registro.id_movimiento}</h5>
      <hr />
      <Grid.Row>
        <Grid.Col md={6}>
          <Form.Group label="Envío">
            <Form.Select value={form.envio ? "true" : "false"} onChange={(e) => handleChange("envio", e.target.value === "true")}>
              <option value="false">No enviado</option>
              <option value="true">Enviado</option>
            </Form.Select>
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label="Estatus">
            <Form.Select
              value={form.estatus}
              onChange={(e) => handleChange("estatus", e.target.value)}
              invalid={!!errores.estatus}
              feedback={errores.estatus}
            >
              <option value="">-- Seleccionar --</option>
              {ESTATUS_OPTIONS.map(op => <option key={op} value={op}>{op}</option>)}
            </Form.Select>
          </Form.Group>
        </Grid.Col>
      </Grid.Row>
      <Grid.Row>
        <Grid.Col md={6}>
          <Form.Group label="ID SAP">
            <Form.Input value={form.idSap} onChange={(e) => handleChange("idSap", e.target.value)} />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label="Moneda">
            <Form.Select value={form.moneda} onChange={(e) => handleChange("moneda", e.target.value)}>
              <option value="">-- Seleccionar --</option>
              <option value="USD">USD</option>
              <option value="MXN">MXN</option>
            </Form.Select>
          </Form.Group>
        </Grid.Col>
      </Grid.Row>
      <Grid.Row>
        <Grid.Col md={6}>
          <Form.Group label="Tarifa">
            <Form.Input
              type="number"
              value={form.tarifa}
              onChange={(e) => handleChange("tarifa", e.target.value)}
              onBlur={() => handleChange("tarifa", normalizarNumero(form.tarifa))}
              invalid={!!errores.tarifa}
              feedback={errores.tarifa}
            />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={3}>
          <Form.Group label="Aplico Descuento">
            <Form.Select value={form.aplicoDescuento ? "true" : "false"} onChange={(e) => handleChange("aplicoDescuento", e.target.value === "true")}>
              <option value="false">No</option>
              <option value="true">Sí</option>
            </Form.Select>
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={3}>
          <Form.Group label="% Descuento">
            <Form.Input
              type="number"
              value={form.porcentajeDescuento}
              onChange={(e) => handleChange("porcentajeDescuento", e.target.value)}
              onBlur={() => handleChange("porcentajeDescuento", normalizarNumero(form.porcentajeDescuento))}
              invalid={!!errores.porcentajeDescuento}
              feedback={errores.porcentajeDescuento}
            />
          </Form.Group>
        </Grid.Col>
      </Grid.Row>
      <Grid.Row>
        <Grid.Col md={4}>
          <Form.Group label="Nota de Crédito">
            <Form.Input value={form.notaCredito} onChange={(e) => handleChange("notaCredito", e.target.value)} />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={4}>
          <Form.Group label="Imputable">
            <Form.Input value={form.imputable} onChange={(e) => handleChange("imputable", e.target.value)} />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={4}>
          <Form.Group label="Folio Factura">
            <Form.Input value={form.folioFactura} onChange={(e) => handleChange("folioFactura", e.target.value)} />
          </Form.Group>
        </Grid.Col>
      </Grid.Row>
      {form.estatus === "Pendiente" && (
        <Grid.Row>
          <Grid.Col md={12}>
            <Form.Group label="Nota (Pendiente)">
              <Form.Input
                value={form.nota}
                onChange={(e) => handleChange("nota", e.target.value)}
                maxLength={100}
                placeholder="Nota para estatus pendiente (máx. 100 caracteres)"
              />
              <small className="text-muted">{form.nota.length}/100</small>
            </Form.Group>
          </Grid.Col>
        </Grid.Row>
      )}
      <div className="text-right mt-3">
        <Button color="primary" onClick={guardar} disabled={guardando}>
          {guardando ? "Guardando..." : "Guardar"}
        </Button>
      </div>
    </div>
  );
};

export default FormFacturacion;
